

import { Observable } from 'rxjs';



export interface TenantMasterPackage {
    id?: string;
  tenantId: string;
  licenseCount: number;
  packageId: string;

}

export abstract class TenantMasterPackageData {
  //abstract fireRequest(data: CountryMst, method: string): Observable<any>;
  abstract getById(url: string): Observable<TenantMasterPackage>;
  abstract list(): Observable<TenantMasterPackage[]>;
  abstract create(url: string,data: any): Observable<any>;
  abstract createArray(url:string,data:any): Observable<any>;
  abstract update(url: string,data: any): Observable<any>;
  abstract delete(url: string): Observable<any>;
}
